import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonJs } from '../../../common/common-js';
import { DataService } from '../../../services/data.service';
import { VaniToasterService } from 'src/app/services/vani-toaster.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-s3bucket',
  templateUrl: './s3bucket.component.html',
  styleUrls: ['./s3bucket.component.css']
})
export class S3bucketComponent implements OnInit {

  s3bucket: FormGroup;
  f1Focused: string = '';
  SaveButtonText: string = 'CONNECT';
  bsModalRef: BsModalRef;

  constructor(
    private fb: FormBuilder,
    public dataService: DataService,
    private toastrService: VaniToasterService,
    public commonjs: CommonJs,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    const response: any = this.commonjs.getAllSettingResponse;
    if (response.is_aws_s3_enable == 1) {
      this.SaveButtonText = 'CONNECTED'
    }

    this.s3bucket = this.fb.group({
      s3_key: [response.s3_key ? response.s3_key : null],
      s3_secret: [response.s3_secret ? response.s3_secret : null],
      s3_region: [response.s3_region ? response.s3_region : null],
      s3_bucket: [response.s3_bucket ? response.s3_bucket : null],
    });
  }

  /** On submit*/
  onSubmit(form: any) {
    const response: any = this.commonjs.getAllSettingResponse;
    if (response.is_google_drive_enable == 1) {
      this.toastrService.notify('warn', '', 'At a time one storage will get connected');
    } else {
      if (!this.checkControlPost(form)) {
        if (this.findInvalidControls().length === 0) {
          this.SaveButtonText = 'CONNECTING';
          form.type = 1;
          this.dataService.awsConfig(form).subscribe((res: any) => {
            this.SaveButtonText = 'CONNECTED';
            if (res.status != 'error') {
              this.toastrService.notify('success', '', res.message);
            } else {
              this.toastrService.notify('warn', '', res.message);
              this.SaveButtonText = 'CONNECT';
            }
          });
        }
      }
    }

    if (this.checkControlPost(form)) {
      this.markFormTouched(this.s3bucket);
    }
  }


  /** Disconnect s3 bucket */
  disConnectS3() {

    var form1 = { type: 1 };
    this.dataService.awsDisconnect(form1).subscribe((res: any) => {
      if (res.status != 'error') {
        this.toastrService.notify('success', '', res.message);
        this.s3bucket = this.fb.group({
          s3_key: [null],
          s3_secret: [null],
          s3_region: [null],
          s3_bucket: [null],
        });
        this.SaveButtonText = 'CONNECT';
      } else {
        this.toastrService.notify('warn', '', res.message);
      }
    });
  }


  /** Check Control Post */
  checkControlPost = (post) => {
    let invalid = false;
    Object.keys(post).forEach((key: string) => {

      if (key === 's3_key' && !this.s3bucket.get(`${key}`).value) {
        this.s3bucket.get(`${key}`).setValidators([Validators.required]);
        this.s3bucket.get(`${key}`).updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return invalid = true;
      }


      if (key === 's3_secret' && !this.s3bucket.get(`${key}`).value) {
        this.s3bucket.get(`${key}`).setValidators([Validators.required]);
        this.s3bucket.get(`${key}`).updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return invalid = true;
      }


      if (key === 's3_region' && !this.s3bucket.get(`${key}`).value) {
        this.s3bucket.get(`${key}`).setValidators([Validators.required]);
        this.s3bucket.get(`${key}`).updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return invalid = true;
      }

      if (key === 's3_bucket' && !this.s3bucket.get(`${key}`).value) {
        this.s3bucket.get(`${key}`).setValidators([Validators.required]);
        this.s3bucket.get(`${key}`).updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return invalid = true;
      }

    });
    return invalid;
  }

  /** Find Invalid Controls */
  findInvalidControls = () => {
    const invalid = [];
    const controls = this.s3bucket.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  /**Mark Form Touched*/
  markFormTouched = (group: FormGroup | FormArray) => {
    Object.keys(group.controls).forEach((key: string) => {
      const control = group.controls[key];
      if (control instanceof FormGroup || control instanceof FormArray) {
        control.markAsTouched();
        this.markFormTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

  // To open confirmation modal
  openConfiramtionModal(template: TemplateRef<any>) {
    this.bsModalRef = this.modalService.show(template);
  }

}
